export default __webpack_public_path__ + "static/media/bar.d8b5cbc7.svg";